import * as React from 'react'
import { Theme, createStyles, WithStyles, Typography, withStyles, Icon } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import Page from 'src/shared/Page/Page'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
    root: {
        position: 'absolute',
        ...css.flexFullCenter,
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    }
});

interface Iprops extends WithI18n,
WithStyles<typeof styles>{}

const FormNotAllow: React.SFC<Iprops> = (props) => {
    return (
        <Page withHead>
            <div className={props.classes.root}>
                <Icon fontSize="large" color="error">warning</Icon>
                <Typography variant="h6" align="center">
                    {props.t.qp_warning_user_without_habilitation}
                </Typography>
            </div>
        </Page>
    )
};

export default compose(
    withI18n,
    withStyles(styles)
)(FormNotAllow)



// WEBPACK FOOTER //
// ./src/page/Consumer/Form/FormNotAllow.tsx